import React from 'react'
import type { GatsbyBrowser } from 'gatsby'

import { PageProviders, RootProviders } from '@HOCs/Providers'
import { resolveCurrentLang } from '@utils/resolveCurrentLang'

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({
  element,
}) => {
  return <RootProviders>{element}</RootProviders>
}

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
  props,
}) => {
  const lang = resolveCurrentLang(
    props.pageContext?.lang as string | undefined,
    props.location?.pathname
  )

  return <PageProviders lang={lang}>{element}</PageProviders>
}
